import {
  PENGELOLAAN_KINERJA_TIM_KINERJA_PS_PATH,
  PENGELOLAAN_KINERJA_PEJABAT_PENILAI_KINERJA_PS_PATH,
  PENGELOLAAN_KINERJA_BASE_PATH,
} from 'app/KinerjaShared/constants/path'

export const getBasePath = (isTimKinerja, isPejabatPenilaiKinerja) => {
  if (isTimKinerja) {
    return PENGELOLAAN_KINERJA_TIM_KINERJA_PS_PATH
  }

  if (isPejabatPenilaiKinerja) {
    return PENGELOLAAN_KINERJA_PEJABAT_PENILAI_KINERJA_PS_PATH
  }

  return PENGELOLAAN_KINERJA_BASE_PATH
}
